/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/fragments-delivery-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/fragments-delivery-api-client";
import type { FragmentsDeliveryAPIClientGetDeliveryStatusQueryResponse, FragmentsDeliveryAPIClientGetDeliveryStatusPathParams, FragmentsDeliveryAPIClientGetDeliveryStatus404 } from "../models/FragmentsDeliveryAPIClientGetDeliveryStatus";

function getFragmentsDeliveryAPIClientGetDeliveryStatusUrl(fragmentId: FragmentsDeliveryAPIClientGetDeliveryStatusPathParams["fragmentId"]) {
  const res = { method: 'GET', url: `/delivery/${fragmentId}` as const }  
  return res
}

/**
 * @description Retrieves the current delivery status and progress for a fragment
 * @summary Get delivery status for a fragment
 * {@link /delivery/:fragmentId}
 */
export async function fragmentsDeliveryAPIClientGetDeliveryStatus(fragmentId: FragmentsDeliveryAPIClientGetDeliveryStatusPathParams["fragmentId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<FragmentsDeliveryAPIClientGetDeliveryStatusQueryResponse, ResponseErrorConfig<FragmentsDeliveryAPIClientGetDeliveryStatus404>, unknown>({ method : "GET", url : getFragmentsDeliveryAPIClientGetDeliveryStatusUrl(fragmentId).url.toString(), ... requestConfig })  
  return res.data
}